import { useEffect, useState } from "react";
import BackGroundColor from "../CommanComponents/BackGroundColor";
import AydınlatmaMetni from "../footer/AydınlatmaMetni";
import GizlilikPolitikası from "../footer/GizlilikPolitikası";
import İptalPolitikası from "../footer/IptalPolitikası";
import KullanımŞartları from "../footer/KullanımSartları";
import SatışSözleşmesi from "../footer/SatışSözleşmesi";
import { useNavigate } from "react-router-dom";
import Contact from "../footer/Contact";
import About from "../footer/About";

function AboutPage() {
  const [activeLevel, setActiveLevel] = useState("About");
  const [activePolicy, setActivePolicy] = useState("KVKK Aydınlatma Metni");
  const navigate = useNavigate();
  const levelSet = [
    { name: "About", tr: "hakkında" },
    { name: "Contact", tr: "iletişim" },
    { name: "Privacy Policy", tr: "gizlilik politikası" },
    { name: "Exıt", tr: "cıkış" },
  ];

  const handleLevelChange = (level) => {
    if (level === "Exıt") {
      navigate("/");
    }
    setActiveLevel(level);
  };

  return (
    <div
      className=" flex flex-col w-full
        gap-4  "
    >
      <div className=" flex flex-col  gap-4 w-full">
        {/* <AboutHeader
          handleLevelChange={handleLevelChange}
          levelSet={levelSet}
          activeLevel={activeLevel}
        /> */}
        <div
          className="flex flex-col lg:flex-row gap-3 md:gap-4 max-w-8xl
       bg-yellow-500 w-full rounded-xl justify-between items-center px-2 py-3 lg:px-6 "
        >
          <div className="w-full md:w-auto flex flex-col">
            <h1
              className="text-xl md:text-2xl font-semibold
          text-white text-center md:text-left"
            >
              Classroom
            </h1>
            <hr className="bg-purple-600 h-0.5 border-none" />
            <p className="text-sm font-medium text-white text-center">
              classroom hakkında bilgiler
            </p>
          </div>

          <div className="flex justify-center gap-2 sm:gap-6 md:gap-8 w-full md:w-auto">
            {levelSet.map((level) => {
              const isExit = level.name === "Exit" || level.name === "Exıt";
              const isActive = activeLevel === level.name;

              return (
                <button
                  key={level.name}
                  onClick={() => handleLevelChange(level.name)}
                  className={`px-2 py-2 md:px-4 text-sm md:text-base  
                font-semibold transition-all rounded-lg group
                ${
                  isExit
                    ? // 🔴 Exit butonu (kırmızı)
                      isActive
                      ? "bg-red-600 text-white shadow-md"
                      : "text-red-500  hover:bg-red-600 hover:text-white"
                    : // 🟣 Diğer butonlar
                      isActive
                      ? "bg-purple-500 text-white shadow-md"
                      : "text-white hover:bg-purple-500"
                }`}
                >
                  <p>{level.name}</p>
                  <hr
                    className={`border-b-2 transition-colors ${
                      isExit
                        ? isActive
                          ? "border-red-400"
                          : "border-red-500 group-hover:border-red-400"
                        : isActive
                          ? "border-yellow-500"
                          : "border-purple-500 group-hover:border-yellow-500"
                    }`}
                  />
                  <p className="text-sm font-medium">{level.tr}</p>
                </button>
              );
            })}
          </div>
        </div>
      </div>
      <div className="flex flex-col  gap-4 w-full">
        {/* About ve Contact için sarmalayıcı */}
        <div className="bg-white rounded-2xl shadow-xl p-4 md:p-8">
          {activeLevel === "About" && <About />}
          {activeLevel === "Contact" && <Contact />}
          {activeLevel === "Privacy Policy" && (
            <div className="min-h-screen">
              <div className="flex flex-col lg:flex-row gap-8">
                {/* Sol menü */}
                <div className="lg:w-1/4">
                  <div className="bg-white rounded-2xl shadow-lg p-6 sticky top-6">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">
                      Yasal Dokümanlar
                    </h2>
                    <div className="space-y-4">
                      {[
                        "KVKK Aydınlatma Metni",
                        "Gizlilik Politikası",
                        "İade ve İptal Politikası",
                        "Kullanım Şartları",
                        "Mesafeli Satış Sözleşmesi",
                      ].map((policy) => (
                        <button
                          key={policy}
                          className={`w-full text-left px-4 py-3 rounded-xl transition-all ${
                            activePolicy === policy
                              ? "bg-purple-500 text-white"
                              : "text-gray-600 hover:bg-gray-100"
                          }`}
                          onClick={() => setActivePolicy(policy)}
                        >
                          {policy}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Sağ içerik */}
                <div className="lg:w-3/4">
                  <div className="bg-white rounded-2xl shadow-lg p-8">
                    {activePolicy === "KVKK Aydınlatma Metni" && (
                      <AydınlatmaMetni />
                    )}
                    {activePolicy === "Gizlilik Politikası" && (
                      <GizlilikPolitikası />
                    )}
                    {activePolicy === "İade ve İptal Politikası" && (
                      <İptalPolitikası />
                    )}
                    {activePolicy === "Kullanım Şartları" && (
                      <KullanımŞartları />
                    )}
                    {activePolicy === "Mesafeli Satış Sözleşmesi" && (
                      <SatışSözleşmesi />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
